export const appsUserInfoMergeDuplicateUsersRules = "/apps/user_info/merge_duplicate_users_rules";
